"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootTransactionsSagas = void 0;
var TransactionsAction_1 = require("@/pages/common/actions/TransactionsAction");
var effects_1 = require("redux-saga/effects");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var DetailTransactionApiSaga_1 = require("@/pages/detail/sagas/api/DetailTransactionApiSaga");
var buildingTransactionsResponseToTransactions_1 = require("@/pages/detail/transfomer/buildingTransactionsResponseToTransactions");
var WindowApi_1 = require("@/api/browser/WindowApi");
var Pages_1 = require("@/rendering/common/Pages");
var getBuildingId = function (state) { return state.transactions.buildingId; };
var getBlockId = function (state) { return state.transactions.buildingId; };
var getDistrictId = function (state) { return state.transactions.districtId; };
var getEstateId = function (state) { return state.transactions.estateId; };
var getPhaseId = function (state) { return state.transactions.phaseId; };
var isBuilding = function (state) {
    if (state.page === Pages_1.Pages.BUILDING)
        return true;
    if (state.page === Pages_1.Pages.BLOCK)
        return false;
    if (state.page === Pages_1.Pages.PROPERTY_DETAIL) {
        var detailState = state;
        return !detailState.detail.building.isBlock;
    }
    return state.transactions.buildingId > 0;
};
var isBlock = function (state) {
    if (state.page === Pages_1.Pages.BLOCK)
        return true;
    if (state.page === Pages_1.Pages.BUILDING)
        return false;
    if (state.page === Pages_1.Pages.PROPERTY_DETAIL) {
        var detailState = state;
        return detailState.detail.building.isBlock;
    }
    return state.transactions.buildingId > 0;
};
var isDistrict = function (state) { return state.transactions.districtId > 0; };
var isEstate = function (state) { return state.transactions.estateId > 0; };
var isPhase = function (state) { return state.transactions.phaseId > 0; };
var watchTransactionChangePage = function () {
    var payload, page, transactionsIsBuilding, transactionsIsBlock, transactionsIsDistrict, transactionsIsEstate, transactionsIsPhase, response, buildingId, blockId, districtId, estateId, phaseId, lang, transactions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 27];
                return [4 /*yield*/, effects_1.take(TransactionsAction_1.default.TRANSACTIONS_ON_TRANSACTION_CHANGE_PAGE)];
            case 1:
                payload = (_a.sent()).payload;
                page = payload;
                return [4 /*yield*/, effects_1.select(isBuilding)];
            case 2:
                transactionsIsBuilding = _a.sent();
                return [4 /*yield*/, effects_1.select(isBlock)];
            case 3:
                transactionsIsBlock = _a.sent();
                return [4 /*yield*/, effects_1.select(isDistrict)];
            case 4:
                transactionsIsDistrict = _a.sent();
                return [4 /*yield*/, effects_1.select(isEstate)];
            case 5:
                transactionsIsEstate = _a.sent();
                return [4 /*yield*/, effects_1.select(isPhase)];
            case 6:
                transactionsIsPhase = _a.sent();
                response = void 0;
                if (!transactionsIsBuilding) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.select(getBuildingId)];
            case 7:
                buildingId = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailTransactionApiSaga_1.getBuildingTransactionsApi, buildingId, page)];
            case 8:
                response = _a.sent();
                return [3 /*break*/, 21];
            case 9:
                if (!transactionsIsBlock) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.select(getBlockId)];
            case 10:
                blockId = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailTransactionApiSaga_1.getBlockTransactionsApi, blockId, page)];
            case 11:
                response = _a.sent();
                return [3 /*break*/, 21];
            case 12:
                if (!transactionsIsDistrict) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.select(getDistrictId)];
            case 13:
                districtId = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailTransactionApiSaga_1.getDistrictTransactionsApi, districtId, page)];
            case 14:
                response = _a.sent();
                return [3 /*break*/, 21];
            case 15:
                if (!transactionsIsEstate) return [3 /*break*/, 18];
                return [4 /*yield*/, effects_1.select(getEstateId)];
            case 16:
                estateId = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailTransactionApiSaga_1.getEstateTransactionsApi, estateId, page)];
            case 17:
                response = _a.sent();
                return [3 /*break*/, 21];
            case 18:
                if (!transactionsIsPhase) return [3 /*break*/, 21];
                return [4 /*yield*/, effects_1.select(getPhaseId)];
            case 19:
                phaseId = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailTransactionApiSaga_1.getPhaseTransactionsApi, phaseId, page)];
            case 20:
                response = _a.sent();
                _a.label = 21;
            case 21:
                if (!response) return [3 /*break*/, 26];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 22:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(buildingTransactionsResponseToTransactions_1.buildingTransactionsResponseToTransactions, response, lang)];
            case 23:
                transactions = _a.sent();
                if (!(transactions && transactions.length)) return [3 /*break*/, 26];
                return [4 /*yield*/, effects_1.put(TransactionsAction_1.default.setTransactions(transactions))];
            case 24:
                _a.sent();
                return [4 /*yield*/, effects_1.put(TransactionsAction_1.default.setCurrentPage(page))];
            case 25:
                _a.sent();
                _a.label = 26;
            case 26: return [3 /*break*/, 0];
            case 27: return [2 /*return*/];
        }
    });
};
var watchTransactionLinkClicked = function () {
    var payload, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(TransactionsAction_1.default.TRANSACTIONS_ON_TRANSACTION_LINK_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                url = payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootTransactionsSagas = {
    watchTransactionChangePage: watchTransactionChangePage,
    watchTransactionLinkClicked: watchTransactionLinkClicked
};
exports.rootTransactionsSagas = rootTransactionsSagas;
